import { Card, EmptyState, Skeleton, Tabs } from "@kontaktfix/ui";
import { PulseIcon } from "@phosphor-icons/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Pagination } from "@/components/contacts-table";
import { AuditLine } from "@/components/history";
import { Page, PageHeader } from "@/components/page";
import { useActivity } from "@/lib/queries";

const PAGE_SIZE = 50;

export function ActivityPage() {
  const { t } = useTranslation();
  const [filter, setFilter] = useState("all");
  const [page, setPage] = useState(1);
  const { data, isLoading } = useActivity({
    entityType: filter === "all" ? undefined : filter,
    page,
    pageSize: PAGE_SIZE,
  });

  return (
    <Page>
      <PageHeader title={t("activity.title")} description={t("activity.description")} />
      <Tabs
        className="mb-4"
        value={filter}
        onValueChange={(v) => {
          setFilter(v);
          setPage(1);
        }}
        tabs={(["all", "contact", "list", "member", "settings"] as const).map((v) => ({
          value: v,
          label: t(`activity.filters.${v}`),
        }))}
      />
      <Card>
        {isLoading ? (
          <div className="flex flex-col gap-2 p-4">
            <Skeleton className="h-10" />
            <Skeleton className="h-10" />
          </div>
        ) : !data?.items.length ? (
          <EmptyState icon={<PulseIcon />} title={t("activity.empty")} />
        ) : (
          <>
            <div className="divide-y divide-border px-5">
              {data.items.map((entry) => (
                <AuditLine key={entry.id} entry={entry} />
              ))}
            </div>
            <Pagination page={page} pageSize={PAGE_SIZE} total={data.total} onPage={setPage} />
          </>
        )}
      </Card>
    </Page>
  );
}
